import { createSlice } from "@reduxjs/toolkit";

import { initialState } from "./interface";

export const AppsSlice = createSlice({
  name: "apps",
  initialState,
  reducers: {
    request: (state) => {
      state.isFetching = true;
      state.isError = false;
      state.fetchedApps = false;
    },
    success: (state, action) => {
      state.isFetching = false;
      state.isError = false;
      state.apps = action.payload;
      state.fetchedApps = true;
    },
    error: (state) => {
      state.isFetching = false;
      state.isError = true;
      state.apps = [];
      state.fetchedApps = false;
    },
  },
});

export const { actions: AppsActions } = AppsSlice;

export default AppsSlice.reducer;
